var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMajesticonsLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 7C1.75 6.53587 1.93437 6.09075 2.26256 5.76256C2.59075 5.43437 3.03587 5.25 3.5 5.25H10.5C10.9641 5.25 11.4092 5.43437 11.7374 5.76256C12.0656 6.09075 12.25 6.53587 12.25 7V11.0833C12.25 11.5475 12.0656 11.9926 11.7374 12.3208C11.4092 12.649 10.9641 12.8333 10.5 12.8333H3.5C3.03587 12.8333 2.59075 12.649 2.26256 12.3208C1.93437 11.9926 1.75 11.5475 1.75 11.0833V7ZM7.58333 8.16667C7.58333 8.01196 7.52187 7.86358 7.41248 7.75419C7.30308 7.64479 7.15471 7.58333 7 7.58333C6.84529 7.58333 6.69692 7.64479 6.58752 7.75419C6.47813 7.86358 6.41667 8.01196 6.41667 8.16667V9.91667C6.41667 10.0714 6.47813 10.2197 6.58752 10.3291C6.69692 10.4385 6.84529 10.5 7 10.5C7.15471 10.5 7.30308 10.4385 7.41248 10.3291C7.52187 10.2197 7.58333 10.0714 7.58333 9.91667V8.16667Z",
    fill: "#A1A1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66666 5.83333V4.08333C4.66666 3.46449 4.9125 2.871 5.35008 2.43342C5.78767 1.99583 6.38116 1.75 7 1.75C7.61884 1.75 8.21233 1.99583 8.64991 2.43342C9.0875 2.871 9.33333 3.46449 9.33333 4.08333V5.83333",
    stroke: "#A1A1A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajesticonsLock);
export default __webpack_public_path__ + "static/media/majesticonsLock.055f62b9c6136ace3abac64698a9c90e.svg";
export { ForwardRef as ReactComponent };